import { client } from './client'

export interface OtpChallengeResponse {
  message: string
  challengeId: string
  expiresIn: number
  resendAfter: number
}

export interface LoginSessionResponse {
  message: string
  user: string
  userId: string
  isVerified: boolean
  role: string
  name: string
}

const requestLoginOtpService = async (
  username: string,
  password: string
): Promise<OtpChallengeResponse | LoginSessionResponse> => {
  const { data } = await client.post('/user/login/otp/request', {
    username,
    password
  })
  return data
}

const verifyLoginOtpService = async (challengeId: string, otp: string): Promise<LoginSessionResponse> => {
  const { data } = await client.post('/user/login/otp/verify', {
    challengeId,
    otp
  })
  return data
}

export { requestLoginOtpService, verifyLoginOtpService }
